import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'

import StepForm from '../../../../../../../features/components/Forms/StepForm'
import AdCreativeTagsFieldsStep from '../../Steps/AdCreativeTagsFieldsStep'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'
import { useSubmitDv360CreateAdsBatch, useSubmitDv360CreateAdsParams } from '../../hooks'
import useIsInternalAdCreation from '../../../../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'
import { transformValuesToBE } from './formatters'

import { validationSchema } from './validation'
import { getInitialValues } from './fields'

const CreativeFileUploadRoute = ({ FormRouteSelector, formProgressItems, lineItemType, ...formProps }) => {
  const submitDv360CreateAdsBatch = useSubmitDv360CreateAdsBatch()
  const createAdsParams = useSubmitDv360CreateAdsParams()

  const isInternalAdCreation = useIsInternalAdCreation()

  const onSubmit = useCallback(
    values => {
      const formattedData = transformValuesToBE({
        values,
        lineItemType,
        ...createAdsParams
      })

      submitDv360CreateAdsBatch(formattedData, values)
    },
    [submitDv360CreateAdsBatch, lineItemType, createAdsParams]
  )

  const initialValues = useMemo(() => getInitialValues(isInternalAdCreation), [isInternalAdCreation])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <AdCreativeTagsFieldsStep lineItemType={lineItemType} />,
        show: true
      }
    ],
    [FormRouteSelector, lineItemType]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default CreativeFileUploadRoute
